import { Component, Input } from '@angular/core';
import { INotification } from '@interfaces/INotification';
import { IAppState } from '@myStore/app.state';
import { ConfirmUser } from '@myStore/users/user.actions';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['../notifications.component.sass'],
})
export class NotificationsListComponent {
  @Input() notifications: INotification[] = [];

  constructor(
    private _store: Store<IAppState>,
    private _toast: ToastrService
  ) {}

  confirmUser(id: number, notificationId: number) {
    this._store.dispatch(new ConfirmUser(id, notificationId));
  }

  checkLinkType(link: string) {
    const lowerCaseLink = link.toLowerCase();
    if (lowerCaseLink.includes('report')) {
      return 'Ссылка для скачивания отчета по импорту : ';
    } else {
      return 'Ссылка на скачивание архива домашних работ : ';
    }
  }
}
